// Routes du module « études » (analyse de dossier avant devis). Conception, devis et catalogue appartiennent à leurs modules.
import type { RouteObject } from 'react-router';
import '../../styles/etudes.css';
import '../../styles/courriers.css';
import { PageEtudes } from './PageEtudes.tsx';
import { PageNouveauDossier } from './PageNouveauDossier.tsx';
import { PageSynthese } from './PageSynthese.tsx';
import { PagePieces } from './PagePieces.tsx';
import { PageExigences } from './PageExigences.tsx';
import { PagePerimetre } from './PagePerimetre.tsx';
import { PageEcarts } from './PageEcarts.tsx';
import { PageCourrier } from './PageCourrier.tsx';

export const routesEtudes: RouteObject[] = [
  { path: 'etudes', element: <PageEtudes /> },
  { path: 'etudes/nouveau', element: <PageNouveauDossier /> },
  { path: 'etudes/:id', element: <PageSynthese /> },
  { path: 'etudes/:id/pieces', element: <PagePieces /> },
  { path: 'etudes/:id/exigences', element: <PageExigences /> },
  { path: 'etudes/:id/perimetre', element: <PagePerimetre /> },
  { path: 'etudes/:id/ecarts', element: <PageEcarts /> },
  { path: 'etudes/:id/courriers/:cid', element: <PageCourrier /> },
];
